import { useState } from "react";
import { Box, CssBaseline, useMediaQuery, useTheme } from "@mui/material";
import AppBar from "./AppBar";
import Drawer from "./Drawer";

const DRAWER_WIDTH = 280;

const Layout = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [mobileOpen, setMobileOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleDrawerToggle = () => {
    if (isMobile) {
      setMobileOpen(!mobileOpen);
    } else {
      setSidebarOpen(!sidebarOpen);
    }
  };

  return (
    <Box sx={{ minHeight: "100vh" }}>
      <CssBaseline />

      {/* AppBar menerima handler toggle */}
      <AppBar
        handleDrawerToggle={handleDrawerToggle}
        sidebarOpen={sidebarOpen}
      />

      {/* Drawer menerima semua state & control */}
      <Drawer
        mobileOpen={mobileOpen}
        handleDrawerToggle={handleDrawerToggle}
        isMobile={isMobile}
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
      />

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: {
            xs: "100%",
            md: sidebarOpen ? `calc(100% - ${DRAWER_WIDTH}px)` : "100%",
          },
          ml: {
            md: sidebarOpen ? `${DRAWER_WIDTH}px` : 0,
          },
          display: "flex", // Tambahkan ini
          flexWrap: "wrap", // Tambahkan ini
          transition: "all 0.3s ease",
          backgroundColor: theme.palette.background.default,
        }}
      >
        {children}
        {/* <Footer /> */}
      </Box>
    </Box>
  );
};

export default Layout;
